import {
  Component, Input, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, EventEmitter, Output, Inject
} from '@angular/core';
import { Router } from '@angular/router';

import { isNullOrUndefined } from '@app/util/util';
import { Promo } from '@shared/sliders/entities/slide-models';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { BenefitViewType } from '@shared/benefits/entities/view-type';

import { SlideAbstractComponent } from '@shared/sliders/abstracts/slide.abstract';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { FinancialPartnersInfoVM } from '@shared/benefits/entities/benefits';
import { searchByDeeplink } from '@shared/sliders/helpers/search-by-deeplink.helper';
import { DefaultSlideWidth } from '@ux/components/slide/entities/slide.types';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';

@Component({
  selector: 'app-slide-promo',
  templateUrl: './slide-promo.component.html',
  styleUrls: ['./slide-promo.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SlidePromoComponent extends SlideAbstractComponent {

  @ViewChild('sectionSlidePromo') content: ElementRef;
  @ViewChild('slidePromo') cellHeader: ElementRef;

  @Input() promos: Promo[];
  @Input() index: number;
  @Input() source: EVENT_SOURCE;
  @Input() isMobile: boolean;
  @Input() salesChannel: string = null;
  @Input() isRappiCard: boolean;

  @Output() selectedPromo: EventEmitter<Promo> = new EventEmitter<Promo>();
  @Output() viewFinancialPartners = new EventEmitter<{
    partnerInfo: FinancialPartnersInfoVM,
    searchBy: SearchBy
  }>();

  public benefitViewType = BenefitViewType.Cms;

  public readonly slideWidth = DefaultSlideWidth;

  constructor(
    protected router: Router,
    protected changeDetector: ChangeDetectorRef,
    protected imageCdnPipe: ImageCdnPipe,
    @Inject(IS_BROWSER) public isBrowser: boolean
  ) {
    super(router, changeDetector, imageCdnPipe)
  }

  public searchByDeeplink(deeplink: string): SearchBy | null {
    return searchByDeeplink(deeplink);
  }

  get activeSlidePromos(): boolean {
    return this.promos.length > 0;
  }

  get oneSlidePromo(): boolean {
    return this.promos.length === 1 && this.isMobile;
  }

  public activeDiscount(promo: Promo): boolean {
    return !isNullOrUndefined(promo.discount_percent) && promo.discount_percent > 0;
  }

  public activeBeforePrice(promo: Promo): boolean {
    return !isNullOrUndefined(promo.price_from_before_discount) ? promo.price_from_before_discount > 0 : false;
  }

  public activePrice(promo: Promo): boolean {
    return !isNullOrUndefined(promo.price_from) ? promo.price_from > 0 : false;
  }

  public activeSubtitle(promo: Promo): boolean {
    return this.activeBeforePrice(promo) || this.activePrice(promo);
  }

  public selectPromo(promo: Promo): void {
    this.selectedPromo.emit(promo);
    this.selectSlide(promo?.deeplink, promo?.deeplink_type);
  }

  public toggleFinancialPartners(partnerInfo: FinancialPartnersInfoVM = null, searchBy: SearchBy = null): void {
    this.viewFinancialPartners.emit({ partnerInfo, searchBy });
  }

}
